var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIconFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16666 3.5L5.19925 5.7849C6.68592 6.62725 7.31406 6.62725 8.80074 5.7849L12.8333 3.5",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17586 7.86077C1.21399 9.64904 1.23306 10.5431 1.89288 11.2055C2.5527 11.8678 3.47102 11.8908 5.30764 11.937C6.43958 11.9655 7.5604 11.9655 8.69236 11.937C10.529 11.8908 11.4473 11.8678 12.1071 11.2055C12.7669 10.5431 12.786 9.64904 12.8241 7.86077C12.8364 7.28578 12.8364 6.71423 12.8241 6.13924C12.786 4.35101 12.7669 3.45689 12.1071 2.79456C11.4473 2.13222 10.529 2.10915 8.69236 2.063C7.5604 2.03456 6.43958 2.03456 5.30763 2.063C3.47102 2.10914 2.5527 2.13221 1.89288 2.79455C1.23305 3.45689 1.21399 4.351 1.17585 6.13924C1.16359 6.71423 1.16359 7.28578 1.17586 7.86077Z",
    stroke: "black",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIconFilled);
export default __webpack_public_path__ + "static/media/messageIconFilled.439337a2d397c940a4eec9077877342f.svg";
export { ForwardRef as ReactComponent };